import * as ExcelJS from 'exceljs';
import { CustomField } from '../../../interfaces/Settings';
import Swal from 'sweetalert2';
import { useIntl } from 'react-intl';
import { checkWhatsapp } from '../../../api/Whatsapp';
import { updateMerchantWithTemplateBulk } from '../../../api/MerchantsCRUD';
import useAccessToken from '../../../hooks/AccessToken';
import { mutate } from 'swr';
import { usePipelineStore } from '../../../stores/PipelineStore';
import useUser from '../../../hooks/User';
import { useMerchantStore } from '../../../stores/MerchantStore';
import { useMeetingStore } from '../../../stores/MeetingsStore';
import { useUserStore } from '../../../stores/UserStore';
import { getCustomFieldsValues } from '../../../functions/ExportTemplateExcel/functionHelperExcel';
import { useProductStore } from '../../../stores/ProductStore';
import { getListIdLabel } from '../../../functions/ExportTemplateExcel/helperTemplateExcel';
interface UseHandleImportMerchantProps {
    customFields: CustomField
    setListData: (data: any) => void
    templateMerchantId: string
    dataUsers: any
    dataCities: any
    selectMultiMerchant: any
    dataSuccess: any
    dataError: any
    dataLabel: any
}

const API_URL = process.env.REACT_APP_API_URL

const useHandleImportMerchant = ({ customFields, setListData, templateMerchantId, dataUsers, dataCities, selectMultiMerchant, dataSuccess, dataError, dataLabel }: UseHandleImportMerchantProps) => {
    const intl = useIntl()
    const token = useAccessToken()
    const { simplePipelines } = usePipelineStore()
    const { simpleMerchants } = useMerchantStore()
    const { simpleMeetings } = useMeetingStore()
    const { simpleProducts } = useProductStore()
    const { users } = useUserStore()
    const user = useUser()

    const checkIsObjectAndExistValue = (value: any) => {
        if (typeof value === 'object' && value !== null) {
            if (value.text) {
                return value.text.trim()
            } else if (value.url) {
                return value.url.trim()
            } else if (value.formula) {
                return value.formula.trim()
            }
        } else if (typeof value === 'number') {
            return value.toString().trim()
        }
        return value?.trim() || null
    }

    const handleChangeMerchant = (e: any) => {
        setListData([]);
        var check_excel = true;
        var empty_excel = false;
        var success = false;
        const file = e;
        const wb = new ExcelJS.Workbook();
        const reader = new FileReader();

        var filteredCustomFieldMerchants = Object.fromEntries(
            Object.entries(customFields).filter(([key, value]) => {
                if (key === '604fa678-e655-4426-918d-aa5fa75d2325') return false
                return value && typeof value === 'object' && value.type !== 'serial'
            })
        );

        reader.readAsArrayBuffer(file);
        reader.onload = () => {
            const buffer: any = reader.result;
            wb.xlsx.load(buffer).then((workbook: any) => {
                const newData: any = [];
                var nameWorksheet = workbook.getWorksheet("Sheet1")
                var nameWorksheetInfo = workbook.getWorksheet("Info")
                if (nameWorksheetInfo !== undefined) {
                    nameWorksheetInfo.eachRow(async (rowInfo: any, rowIndexInfo: number) => {
                        if (rowIndexInfo > 3) {
                            if (rowInfo.values[2] === `Template Insert Merchant ${templateMerchantId}` || rowInfo.values[2] === `Template Error Insert Merchant ${templateMerchantId}`) {
                                nameWorksheet?.eachRow((row: any, rowIndex: number) => {
                                    if (rowIndex > 2) {
                                        const rowData = row.values
                                        if (Array.isArray(rowData)) {
                                            var pic: any = dataUsers.find((data: any) => data.name === rowData[2]);
                                            var city: any = dataCities.find((data: any) => data.name === rowData[4]);
                                            let listIdLabel = getListIdLabel(dataLabel, rowData[3]).map((label: any) => { return { id: label } }) || null

                                            const customFieldsStartIndex = 7; // mulai dari kolom ke 7 untuk custom field
                                            const customFieldsData = Object.fromEntries(Object.keys(filteredCustomFieldMerchants).map((key, index) => {
                                                const rowIndex = customFieldsStartIndex + index;
                                                const rowValue = rowData[rowIndex];
                                                const fieldType = filteredCustomFieldMerchants[key].type;
                                                let fieldValue;

                                                if (fieldType === 'image' || fieldType === 'file' || fieldType === 'text' || fieldType === 'link' || fieldType === 'email' || fieldType === 'video') {
                                                    fieldValue = typeof rowValue === 'object' ? rowValue.text : rowValue;
                                                } else {
                                                    fieldValue = rowValue;
                                                }

                                                return [key, fieldValue];
                                            }));

                                            newData.push({
                                                name: checkIsObjectAndExistValue(rowData[1]),
                                                label_name: rowData[3],
                                                label_id: listIdLabel,
                                                pic_id: pic?.id,
                                                pic_name: pic?.name,
                                                city_id: city?.id,
                                                city_name: city?.name,
                                                phone: checkIsObjectAndExistValue(rowData[5]),
                                                email: checkIsObjectAndExistValue(rowData[6]),
                                                ...customFieldsData,
                                            })

                                            check_excel = true
                                            success = true
                                            empty_excel = false
                                        }
                                    } else {
                                        empty_excel = true
                                        return false
                                    }
                                });
                            } else if (rowInfo.values[2] === `Template Update Merchant ${templateMerchantId}` || rowInfo.values[2] === `Template Error Update Merchant ${templateMerchantId}`) {
                                nameWorksheet?.eachRow((row: any, rowIndex: number) => {
                                    if (rowIndex > 2) {
                                        const rowData = row.values
                                        if (Array.isArray(rowData)) {
                                            let id = atob(rowData[1])
                                            let pic: any = dataUsers.find((data: any) => data.name === rowData[3]);
                                            let city: any = dataCities.find((data: any) => data.name === rowData[5]);
                                            let listIdLabel = getListIdLabel(dataLabel, rowData[4]).map((label: any) => { return { id: label } }) || null

                                            const customFieldsStartIndex = 8; // mulai dari kolom ke 8 untuk custom field update
                                            const customFieldsData = Object.fromEntries(Object.keys(filteredCustomFieldMerchants).map((key, index) => {
                                                const rowIndex = customFieldsStartIndex + index;
                                                const rowValue = rowData[rowIndex];
                                                const fieldType = filteredCustomFieldMerchants[key].type;
                                                let fieldValue;

                                                if (fieldType === 'image' || fieldType === 'file' || fieldType === 'text' || fieldType === 'link' || fieldType === 'email' || fieldType === 'video') {
                                                    fieldValue = typeof rowValue === 'object' ? rowValue.text : rowValue;
                                                } else {
                                                    fieldValue = rowValue;
                                                }

                                                return [key, fieldValue];
                                            }));

                                            newData.push({
                                                id: id.slice(0, 3) + id.slice(6),
                                                name: checkIsObjectAndExistValue(rowData[2]),
                                                label_name: rowData[4],
                                                label_id: listIdLabel,
                                                pic_id: pic?.id,
                                                pic_name: pic?.name,
                                                city_id: city?.id,
                                                city_name: city?.name,
                                                phone: checkIsObjectAndExistValue(rowData[6]),
                                                email: checkIsObjectAndExistValue(rowData[7]),
                                                ...customFieldsData,
                                            })

                                            check_excel = true
                                            success = true
                                            empty_excel = false
                                        }
                                    } else {
                                        empty_excel = true
                                        return false
                                    }
                                });
                            }
                            else {
                                check_excel = false
                                return false
                            }
                        }
                    })
                } else {
                    check_excel = false
                }
                if (empty_excel) {
                    Swal.fire({
                        icon: 'error',
                        title: intl.formatMessage({ id: 'FORM.VALIDATION.FILL_DATA_FIRST' }),
                        confirmButtonText: 'Ok'
                    });
                }

                if (!check_excel) {
                    Swal.fire({
                        icon: 'error',
                        title: intl.formatMessage({ id: 'FORM.VALIDATION.EXCEL_TEMPLATE_NOT_MATCHING' }),
                        confirmButtonText: 'Ok'
                    });
                }
                if (success) setListData(newData);
            });
        };
    };

    const chunkArray = (array: any[], size: number) => {
        const result = [];
        for (let i = 0; i < array.length; i += size) {
            result.push(array.slice(i, i + size));
        }
        return result;
    };

    const handleBulkInsertMerchant = async (data: any[], batchSize: number = 200) => {
        const dataBatches = chunkArray(data, batchSize);
        for (const batch of dataBatches) {
            const merchants = await Promise.all(batch.map(async (item) => {
                const responses = await checkWhatsapp(item.phone);
                const getStatusCode = responses.status;
                const isWhatsappPhone = getStatusCode === 200 ? responses.data.result.exists : null;
                const customFieldsValues = getCustomFieldsValues(item, customFields, simplePipelines, simpleMerchants, simpleMeetings, simpleProducts, users, user);

                return {
                    id: item.id,
                    merchantTemplateId: selectMultiMerchant.id,
                    ownerName: item.pic_name,
                    labelsName: item.label_name,
                    cityName: item.city_name,
                    merchantLabels: item.label_id ?? [],
                    ownerId: item.pic_id,
                    name: item.name,
                    cityId: item.city_id,
                    phone: item.phone ? item.phone.toString().replace("+", "") : "",
                    isWhatsappPhone,
                    email: item.email ? item.email : null,
                    customFields: customFieldsValues,
                    copyOriginalValueCustomField: Object.keys(customFields).reduce((acc, field) => {
                        acc[field] = item[field] ?? null;
                        return acc;
                    }, {} as any)
                };
            }));

            const response = await updateMerchantWithTemplateBulk({
                merchants: merchants,
                token: token
            });

            if (response.data.success) {
                mutate(`${API_URL}merchants${templateMerchantId ? `?merchantTemplateId=${templateMerchantId}` : ""}`);

                const updatedData = response.data.data.validMerchants?.map((item: any) => ({
                    ...item,
                    lastMeetEnd: "-",
                    lastLeadCreatedTime: "-",
                    dateCreated: item.dateCreated
                })) || [];

                dataSuccess.push(...updatedData);

                if (response.data.data.invalidMerchants && response.data.data.invalidMerchants.length > 0) {
                    const invalidResponseData = response.data.data.invalidMerchants.map((itemMerchant: any) => ({
                        id: itemMerchant.data.id,
                        name: itemMerchant.data.name,
                        pic_name: itemMerchant.data.ownerName,
                        label_name: itemMerchant.data.labelsName,
                        city_name: itemMerchant.data.cityName,
                        phone: itemMerchant.data.phone,
                        email: itemMerchant.data.email,
                        ...itemMerchant.data.copyOriginalValueCustomField,
                        error: itemMerchant.error || "Invalid data",
                    }));
                    dataError.push(...invalidResponseData);
                }
            } else {
                if (response.data.errors) {
                    Swal.fire({
                        icon: 'error',
                        title: response.data.errors.msg || "Invalid data",
                        confirmButtonText: 'Ok'
                    });
                }
            }
        }
    }



    return {
        handleChangeMerchant,
        handleBulkInsertMerchant
    }
}

export default useHandleImportMerchant